export enum Scopes {
  Account = 'account',
  CreditAnalysis = 'credit_analysis',
  MerchantStatusPage = 'merchant_status',
  MerchantOrdersHistoryPage = 'merchant_orders_history',
  MerchantSignupPage = 'merchant_signup',
  PortolioAssociation = 'portfolio_association',
  OrderCreation = 'order_creation',
  OrderStatus = 'order_status',
  NotificationCentral = 'notification_central',
  Homepage = 'homepage',
  HighlightCard = 'highlight_card',
  PendingBoleto = 'pending_boleto',
  Settings = 'settings',
  ModalNotification = 'modal_notification',
  ModalCsat = 'modal_csat',
  IncreaseLimit = 'increase_limit',
}

export enum ScopesPayment {
  MerchantTour = 'merchant_tour',
  Dashboard = 'dashboard',
  Bills = 'bills',
  AppGTM = 'app_gtm',
  Partners = 'partners',
  BillsPreviewLineItem = 'bills_preview_line_item',
  PaymentObligations = 'payment_obligations',
}
